import { render, staticRenderFns } from "./SenderCard.vue?vue&type=template&id=546a0726&"
import script from "./SenderCard.vue?vue&type=script&lang=js&"
export * from "./SenderCard.vue?vue&type=script&lang=js&"
import style0 from "./SenderCard.vue?vue&type=style&index=0&id=546a0726&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports